export const SECRET =
  '650f3660830806dd28499978bdc250636709e119152c02aa8eb85e1b477e9d10';
